export default {
    carregando: false,
    items: [],
    itemsDeletados: [],
    selecionado: {},
    relacoesListagem: []
}